// src/components/ActiveSwarmsTabsSkeleton.js

import React from 'react';
import { Box, Tabs, Tab, Skeleton, Grid } from '@mui/material';

/**
 * Component that displays skeleton placeholders for ActiveSwarmsTabs.
 * This is shown while the data is loading.
 * @returns {JSX.Element} The skeleton component.
 */
const ActiveSwarmsTabsSkeleton = () => {
  return (
    <div style={{ width: "100%" }}>
      {/* Skeleton for Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: '1em' }}>
        <Tabs 
          value={false} 
          aria-label="Active Swarms Time Slots Tabs Skeleton" 
          variant="scrollable" 
          scrollButtons="auto"
        >
          {/* Render multiple Skeleton Tabs */}
          {Array.from(new Array(3)).map((_, index) => (
            <Tab 
              key={index} 
              label={<Skeleton variant="text" width="80%" />} 
              disabled 
            />
          ))}
        </Tabs>
      </Box>
      
      {/* Skeleton for ActiveSwarmList */}
      <Box sx={{ padding: '1em' }}>
        <Grid 
          container 
          spacing={2} // Adjusts the space between Grid items
          justifyContent="flex-start" // Aligns items to the start of the container
        >
          {/* Render multiple Skeleton Cards */}
          {Array.from(new Array(6)).map((_, index) => (
            <Grid 
              item 
              key={index} 
              xs={12} sm={6} md={4} lg={3} // Responsive grid sizes
            >
              
              <Skeleton variant="rectangular" width="100%" height={200} />
              
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
};

export default ActiveSwarmsTabsSkeleton;
